export const physiologyModule = {
  id: "physiology",
  title: "Skeletal Physiology",
  sections: [
    {
      type: "text",
      content:
        "<p>The skeletal system provides structural support and plays roles in movement, protection, and mineral storage. This module covers bone remodeling, calcium homeostasis, and hematopoiesis.</p>",
    },
    {
      type: "text",
      content:
        "<p>Content coming soon. Add your physiology content here.</p>",
    },
  ],
};
